import React, { SyntheticEvent } from 'react'
import { useTheme } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Grid from '@mui/material/Grid'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Box } from '@mui/material'
import {
    useGetIdsHealthcareservicesHcsIdPatientsPatientIdConsultations,
    useGetIdsHealthcareservicesHcsIdPatientsPatientIdTransmissions,
} from '@toktokdoctech/tokapi-client'
import PatientConsultationHistory from './PatientConsultationHistory'
import PatientTransmissionHistory from './PatientTransmissionHistory'
import sxs from './styles/_sxs'
import { PatientHistoryTabsProps } from './_props'
import useCurrentHcs from '../../../hooks/useCurrentHcs'

const TabPanel = (props: any) => {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabs-panel-${index}`}
            aria-labelledby={`tabs-history-${index}`}
            {...other}
        >
            {value === index && <Grid container>{children}</Grid>}
        </div>
    )
}

const a11yProps = (index: number) => ({
    id: `tabs-panel-${index}`,
    'aria-controls': `tabs-history-${index}`,
    'data-cy': `patientHistoryTabPanel-${index}`,
})

const PatientHistoryTabs = ({ patient }: PatientHistoryTabsProps) => {
    const theme = useTheme()
    const large = useMediaQuery(theme.breakpoints.up('sm'))
    const [value, setValue] = React.useState(0)
    const [page, setPage] = React.useState(0)
    const [itemsPerPage, setItemsPerPage] = React.useState(5)
    const currentHcs = useCurrentHcs()

    const {
        data: consultations,
        isLoading: isConsultationsLoading,
        isError: isConsultationsError,
    } = useGetIdsHealthcareservicesHcsIdPatientsPatientIdConsultations(currentHcs.id, patient.id, {
        limit: itemsPerPage,
        skip: page * itemsPerPage,
        isActFinished: true,
    })

    const {
        data: transmissions,
        isLoading: isTransmissionsLoading,
        isError: isTransmissionsError,
    } = useGetIdsHealthcareservicesHcsIdPatientsPatientIdTransmissions(currentHcs.id, patient.id, {
        limit: itemsPerPage,
        skip: page * itemsPerPage,
    })

    const consultationsCount = consultations?.total ?? 0
    const transmissionsCount = transmissions?.total ?? 0

    const handleChange = (_: SyntheticEvent, newValue: number) => {
        setValue(newValue)
        setPage(0)
        setItemsPerPage(5)
    }

    const handlePaginationChange = (event: React.MouseEvent<HTMLButtonElement> | null, newValue: number) => {
        setPage(newValue)
    }

    const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value: newValue } = event.target
        setItemsPerPage(parseInt(newValue))
        setPage(0)
    }

    return (
        <Box sx={sxs.root}>
            <AppBar position="static" sx={sxs.tabs}>
                <Tabs
                    TabIndicatorProps={{
                        sx: sxs.tabIndication,
                    }}
                    value={value}
                    variant="fullWidth"
                    onChange={handleChange}
                    aria-label="tabs-history"
                    scrollButtons="auto"
                >
                    <Tab label={`${large ? 'Téléconsultations' : 'TLC'} (${consultationsCount})`} {...a11yProps(0)} />
                    <Tab label={`${large ? 'Téléexpertises' : 'TLE'} (${transmissionsCount})`} {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <PatientConsultationHistory
                    patient={patient}
                    data={consultations}
                    isLoading={isConsultationsLoading}
                    isError={isConsultationsError}
                    page={page}
                    itemsPerPage={itemsPerPage}
                    handlePaginationChange={handlePaginationChange}
                    handleItemsPerPageChange={handleItemsPerPageChange}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <PatientTransmissionHistory
                    patient={patient}
                    data={transmissions}
                    isLoading={isTransmissionsLoading}
                    isError={isTransmissionsError}
                    page={page}
                    itemsPerPage={itemsPerPage}
                    handlePaginationChange={handlePaginationChange}
                    handleItemsPerPageChange={handleItemsPerPageChange}
                />
            </TabPanel>
        </Box>
    )
}

export default PatientHistoryTabs
